import { ActionIcon, Button, Modal } from "rizzui";
import React, { useState } from "react";
import { PiXBold } from "react-icons/pi";
import { Z_MODAL } from "@/config/zModal";

export const LeadQualityScore = ({
  title = "",
  button = "",
  children,
}: {
  title: string;
  button: React.ReactNode;
  children: React.ReactNode;
}) => {
  const [modalState, setModalState] = useState(false);
  return (
    <div>
      <Button onClick={() => setModalState(true)}>{button}</Button>
      <Modal
        isOpen={modalState}
        onClose={() => setModalState(false)}
        customSize="600px"
        className={Z_MODAL.LEAD_QUALITY_SCORE}
      >
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <label className="text-lg font-bold">{title}</label>
            <ActionIcon
              size="sm"
              variant="text"
              onClick={() => setModalState(false)}
              className="p-0 text-gray-500 hover:!text-gray-900"
            >
              <PiXBold className="h-5 w-5" />
            </ActionIcon>
          </div>
          {children}
        </div>
      </Modal>
    </div>
  );
};
